// extracted by mini-css-extract-plugin
export default {"container":"Roles_container__7mJX4"};